module.exports = __webpack_public_path__ + "img/PeepsAbove.3ce46df5.svg";